import { PasswordFormController } from './passwordForm.controller';
import template from './passwordForm.html';

export const passwordFormComponent = {
  name: 'passwordForm',
  restrict: 'E',
  transclude: true,
  template,
  controller: PasswordFormController,
  controllerAs: 'vm',
  bindings: {
    onChange: '&',
    mandatory: '<',
    form: '='
  }
};
